import { Lightning } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import { MediaModel } from "../../lib/models";
import theme from "../../lib/theme";
import configs from "../../lib/configs";
import { Button } from "../../components/input/Button/Button";
import { Theme, themeManager } from "../../components/configurations/Theme/ThemeManager";
import { MENU_WIDTH } from "../../lib/utils";
import { SeriesDetailsCompact } from "./components/SeriesDetails/SeriesDetailsCompact";
import { SeriesDetailsFullScreen } from "./components/SeriesDetails/SeriesDetailsFullScreen";
import { MediaList } from "../../components/data-display/MediaList/MediaList";

interface SeriesSingleTemplateSpec extends Lightning.Component.TemplateSpec {
    Page: {
        Movie: typeof SeriesDetailsCompact | typeof SeriesDetailsFullScreen;
        Seasons: typeof List;
        List: typeof MediaList;
    };
}

interface SeriesSingleTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class SeriesSingle
    extends Lightning.Component<SeriesSingleTemplateSpec, SeriesSingleTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<SeriesSingleTemplateSpec>
{
    _selectedSeason = 0;
    _hasSeasons = false;
    _data!: MediaModel;
    private _themeCallback!: (customTheme: Theme | undefined) => void;

    static _offsetX = configs.layout.content.alignWithBanner ? theme.banner.padding.x : theme.layout.content.x;

    static override _template(): Lightning.Component.Template<SeriesSingleTemplateSpec> {
        return {
            collision: true,
            Page: {
                Movie: {
                    w: theme.layout.w,
                    x: MENU_WIDTH,
                    collision: true,
                    type: configs.layout.mediaSingle.fullWidth ? SeriesDetailsFullScreen : SeriesDetailsCompact
                },
                Seasons: {
                    type: List,
                    collision: true,
                    spacing: 16,
                    y: configs.layout.mediaSingle.fullWidth ? 655 : theme.banner.h + 32,
                    w: theme.layout.w - this._offsetX * 2 - MENU_WIDTH,
                    x: MENU_WIDTH + this._offsetX,
                    signals: { onIndexChanged: true }
                },
                List: {
                    type: MediaList,
                    collision: true,
                    h: theme.episodeItem.h,
                    w: theme.layout.w - this._offsetX * 2 - MENU_WIDTH,
                    y: configs.layout.mediaSingle.fullWidth
                        ? 655 + 72
                        : theme.banner.h + (configs.hasSeasons ? 120 : 82),
                    x: MENU_WIDTH + this._offsetX
                }
            }
        };
    }

    readonly Page = this.getByRef("Page")!;
    readonly Seasons = this.Page.getByRef("Seasons")!;
    readonly List = this.Page.getByRef("List")!;
    readonly Movie = this.Page.getByRef("Movie")!;

    set data(movie: MediaModel) {
        const querySeason = window.currentSeason;
        window.selectedMovie = {
            ...movie,
            seasonNumber: querySeason || (movie.seasons?.length ? movie.seasons[0]!.seasonNumber : undefined)
        };

        const querySeasonIndex = querySeason ? movie.seasons?.findIndex((s) => s.seasonNumber == querySeason) : -1;
        this._selectedSeason = !querySeasonIndex || querySeasonIndex === -1 ? 0 : querySeasonIndex;

        console.log("querySeason", querySeason);
        console.log("querySeasonIndex", querySeasonIndex);
        console.log("_selectedSeason", this._selectedSeason);

        this._data = movie;

        this.application.emit("updateSelectedMovie", window.selectedMovie);

        this.application.emit("clearBackground");
        this.application.emit("updateSelectedMovie", movie);

        this.Movie.data = movie;

        const episodes = this._data?.items || this._data?.seasons![this._selectedSeason]?.episodes || [];
        this.List.resetItems(episodes);
        const parentId = this._data?.seasons?.[this._selectedSeason]?.id || this._data?.id;
        // if (!episodes.length && parentId) {
        this.List.patch({
            seriesId: this._data.id,
            parentId: parentId,
            isEpisodes: true
        });
        // this.List.clear();
        // this.List.onRequestItems();
        // }

        if (configs.hasSeasons && movie.seasons) {
            this._hasSeasons = true;
            this.Seasons.items = movie.seasons.map((item, index) => ({
                type: Button,
                isActive: this._selectedSeason === index,
                useBorder: true,
                // label: `Season ${item.seasonNumber}`,
                label: {
                    key: "general.seasonNumber",
                    value: item.seasonNumber
                },
                h: theme.button.h,
                w: theme.button.secondary.w,
                actionId: "season"
            }));
        } else {
            this._hasSeasons = false;
        }
    }

    override _init() {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    // Neeed to work on this
    private _onThemeChange(customTheme: Theme | undefined): void {
        // console.log('customTheme---', customTheme, Colors(theme.colors.bg.primary).get());
        // this.Details?.patch({
        //   text: {
        //     textColor: customTheme?.paragraph ?? Colors(theme.colors.text
        //     .primary).get(),
        //   }
        // });
    }

    // season has changed
    async $handleBtnClick() {
        if (this._selectedSeason === this.Seasons.index) return;

        this._selectedSeason = this.Seasons.index;

        this.Seasons.items.map((item: any, index: number) => {
            item.isActive = this._selectedSeason === index;
            return item;
        });

        window.selectedMovie = {
            ...this._data,
            seasonNumber: this._data.seasons![this._selectedSeason]!.seasonNumber
        };

        const episodes = this._data.seasons![this._selectedSeason]!.episodes || [];

        if (!episodes.length) {
            this.List.clear();
            // this.List.resetItems(episodes);
            const parentId = this._data.seasons![this._selectedSeason]!.id;
            this.List.patch({
                parentId: parentId
            });
            // this.List.clear();
            const episodes = await this.List.reloadItems();
            if (episodes) {
                this._data.seasons![this._selectedSeason]!.episodes = episodes;
            }
        } else {
            this.List.resetItems(this._data.seasons![this._selectedSeason]!.episodes || []);
        }
    }

    // season has changed
    onIndexChanged({ index }: any) {
        if (this._hasSeasons) {
            window.selectedMovie = {
                ...this._data,
                releaseYear: this._data.seasons![index]?.releaseYear,
                seasonNumber: this._data.seasons![index]!.seasonNumber
            };
            this.application.emit("updateSelectedMovie", window.selectedMovie!);
        }
    }

    override _getFocused(): any {
        return this.List;
    }

    override _active() {
        if (window.seasonSelectedIndex) {
            this._selectedSeason = window.seasonSelectedIndex;
            this.List.resetItems(this._data.seasons![this._selectedSeason]!.episodes || []);
            this.Seasons.items.map((item: any, index: number) => {
                item.isActive = this._selectedSeason === index;
                return item;
            });

            this.Seasons.index = window.seasonSelectedIndex;

            this.onIndexChanged({
                index: window.seasonSelectedIndex
            });

            window.seasonSelectedIndex = undefined;
        }

        if (window.selectedIndex) {
            this.List.index = window.selectedIndex;
            window.selectedIndex = undefined;
        }
    }

    override _handleUp() {
        if (this._hasSeasons) {
            this._setState("SeasonState");
        } else {
            window.selectedMovie = {
                ...this._data
                // description: this._data.description || window.selectedMovie?.description,
                // fsk: this._data.fsk || window.selectedMovie?.fsk,
                // resolution: this._data.resolution || window.selectedMovie?.resolution,
                // languages: this._data.languages || window.selectedMovie?.languages,
                // subtitles: this._data.subtitles || window.selectedMovie?.subtitles,
            };
            this.application.emit("updateSelectedMovie", window.selectedMovie);

            this._setState("TopState");
        }
    }

    // override _handleDown() {
    //     if (this._hasSeasons) {
    //         this._setState("SeasonState");
    //     } else {
    //         this._setState("");
    //     }
    // }

    static override _states() {
        return [
            class TopState extends this {
                override _getFocused() {
                    return this.Movie;
                }

                override _handleUp() {}

                override _handleDown() {
                    if (this._hasSeasons) {
                        this._setState("SeasonState");
                    } else {
                        this._setState("");
                    }
                }
            },

            class SeasonState extends this {
                override _getFocused() {
                    return this.Seasons;
                }

                override _handleUp() {
                    this.onIndexChanged({
                        index: this._selectedSeason
                    });

                    this._setState("TopState");
                }

                override _handleDown() {
                    this.onIndexChanged({
                        index: this._selectedSeason
                    });

                    this._setState("");
                }
            }
        ];
    }
}
